export default __webpack_public_path__ + "static/media/pending.5d3119a0.svg";